import React, { useEffect } from 'react';
import TermsAndConditions from './TermsAndConditions';

const TracsessTuneTerms: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <TermsAndConditions
      appName="Tracsess Tune"
      pdfUrl="https://tracess.s3.ap-south-1.amazonaws.com/documents/tune/TOS_Tracsess_Tune.pdf"
      title="Tracsess Tune - Terms and Conditions"
    />
  );
};

export default TracsessTuneTerms; 